/**
 * Key mappings for platform-specific modifier keys.
 * Mac uses symbols, Windows/Linux uses text labels.
 */
export var MAC_KEY_MAP = {
  cmd: "⌘",
  command: "⌘",
  ctrl: "⌃",
  control: "⌃",
  alt: "⌥",
  option: "⌥",
  opt: "⌥",
  shift: "⇧",
  meta: "⌘",
  enter: "⏎",
  "return": "⏎"
};
export var WINDOWS_KEY_MAP = {
  cmd: "Ctrl",
  command: "Ctrl",
  ctrl: "Ctrl",
  control: "Ctrl",
  alt: "Alt",
  option: "Alt",
  opt: "Alt",
  shift: "Shift",
  meta: "Win",
  enter: "Enter",
  "return": "Enter"
};